export default {
  titles: {
    encoding: 'Codificación',
    inbound: 'Entrante',
    user_info: 'Información del usuario',
    settings: 'Configuración',
    reset_daily_items: '¿Restablecer elementos diarios?',
    last_parcels: 'Últimos paquetes',
    select_item: 'Seleccionar artículo',
    select_workstation: 'Seleccionar estación de trabajo',
    select_language: 'Seleccionar idioma',
    support: 'Soporte',
    select_printer: 'Seleccionar impresora',
    shipment_to_confirm: 'Envío por confirmar',
    sorting_details: 'Detalles de la distribución',
    inventories: 'Inventarios',
    pin_modal: 'Introduce el PIN para forzar la asociación',
    shipments: 'Envíos',
    report_problem: 'Informar de un problema',
    parcels: 'Paquetes',
    //moncler
    outbound_bthp: 'Certificado BTHP Saliente'
  },
  simple_parcel_list: {
    to_read: 'Por leer',
    ok: 'Ok',
    force: 'Forzar',
    force_parcel: 'Forzar paquete {{code}}',
    force_parcel_desc: 'Inserta el PIN del usuario para forzar el paquete',
    forced: 'Forzado',
    unexpected: 'Inesperado',
    remove: 'Eliminar',
    invalid_pin: 'PIN del usuario no válido',
    loading: 'Cargando lista de cajas'
  },
  create_parcel_gate: {
    //moncler
    width: 'Width',
    height: 'Height',
    depth: 'Depth',
    tare: 'Tare',
    description: 'Description'
  },
  fields: {
    current_location: 'Ubicación actual',
    identified_item: 'Artículo identificado',
    ignored_items: 'Artículos ignorados',
    ignored_with_reason_items: 'Artículos ignorados con razón',
    error_items: 'Artículos con error',
    warning_items: 'Artículos con advertencia',
    umg: 'Umg',
    custom_class: 'Clase personalizada',
    product_code: 'Código de producto',
    as400username: 'Usuario AS400',
    item_components: 'Componentes',
    sender: 'Remitente',
    year: 'Año',
    number: 'Número',
    row: 'Fila',
    entity: 'Entidad',
    //valentino
    mission: 'Misión',
    mission_type: 'Tipo de misión',
    supplier: 'Proveedor',
    physical_storage: 'Almacenamiento físico',
    season: 'Temporada',
    ddt: 'DDT',
    notification: 'Notificación',
    ddt_date: 'Fecha DDT',
    notification_date: 'Fecha de notificación',
    product_category: 'Categoría del producto'
  },
  misc: {
    select_an_option: 'Seleccionar una opción...',
    not_set: 'No establecido',
    current_value: 'Valor actual',
    pleaseWait: 'Por favor, espera...',
    not_associated: 'Not associated',
    replaced: 'Replaced',
    production_order_info: 'Production Order Info',
    reel_info: 'Reel Info',
    reel_code: 'Reel Code',
    assigned_supplier: 'Assigned Supplier',
    type: 'Type',
    identifier_info: 'Identifier Info',
    identifier_events: 'Identifier Events',
    or: 'o',
    select_place: 'Hola {{user}}, selecciona tu lugar de origen para continuar',
    back: 'Atrás',
    refresh: 'Actualizar',
    reload: 'Recargar',
    save: 'Guardar',
    confirm: 'Confirmar',
    confirm_auto: 'Autoconfirmar',
    update_and_confirm: 'Actualizar y confirmar',
    update: 'Actualizar',
    no_carton_found: 'No se encontró ninguna caja',
    confirm_continue: 'Confirmar y continuar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    user: 'Usuario',
    workstation: 'Estación de trabajo',
    username: 'Nombre de usuario',
    name: 'Nombre',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    encoding: 'Codificación',
    code: 'Código',
    ean_code: 'Código EAN',
    certilogo: 'Certilogo',
    enter_the_necessary_fields: 'Introduce los campos necesarios para iniciar la operación',
    associated_items: 'Artículos asociados',
    associate: 'Asociar',
    associated: 'Asociado',
    verify: 'Verificar',
    verify_association: 'Verify',
    reading: 'Leyendo',
    processing: 'Procesando',
    association: 'Asociación',
    associations: 'Asociaciones',
    waiting: 'Esperando',
    writing: 'Escribiendo',
    writing_progress: 'Escritura en curso...',
    partial_confirm: 'Confirmación parcial',
    retry: 'Reintentar',
    writing_association: 'Escritura y asociación',
    confirmed: 'Confirmado',
    unable_to_write: 'No se pudo escribir la etiqueta EPC: {{code}} para el producto: {{productCode}}',
    unable_to_get_next_epc: 'No se pudo obtener el siguiente EPC para: {{productCode}}',
    unable_to_connect_to_workstation: 'No se pudo conectar a la estación de trabajo',
    tag_info: 'Información de la etiqueta',
    inbound: 'Entrante',
    outbound: 'Salida',
    stop: 'Parar',
    start: 'Iniciar',
    pause: 'Pausa',
    clear: 'Limpiar',
    tag_encoded_today: 'Etiqueta codificada hoy',
    transaction_date: 'Fecha de la transacción',
    select_transaction_date: 'Seleccionar fecha de transacción',
    ready_to_receive: 'Listo para recibir',
    change_password: 'Cambiar contraseña',
    logout: 'Cerrar sesión',
    are_you_sure_to_logout: '¿Realmente quieres cerrar sesión?',
    settings: 'Configuraciones',
    roles: 'Roles',
    email: 'Correo electrónico',
    place: 'Lugar',
    items: 'Artículos',
    description: 'Descripción',
    color: 'Color',
    size: 'Talla',
    part: 'Parte',
    total_reads: 'LECTURAS TOTALES',
    total_ok: 'TOTAL OK',
    save_to_list: 'Guardar en la lista',
    destination: 'Destino',
    origin: 'Origen',
    new_parcel: 'Nueva caja',
    status: 'Estado',
    parcel: 'Caja',
    read_parcel: 'Leer caja',
    parcels: 'Cajas',
    shipment: 'Envío',
    creation_date: 'Fecha de creación',
    search: 'Buscar',
    select_search: 'Buscar...',
    detail: 'Detalle',
    quantity: 'Cantidad ({{quantity}})',
    only_quantity: 'Cantidad',
    style: 'Estilo',
    material: 'Material',
    shipment_code_auto: 'Código de envío (auto)',
    parcel_code_auto: 'Código de caja(auto)',
    next: 'Siguiente',
    parcels_to_receive: 'Cajas por recibir',
    confirm_parcel: 'Confirmar caja',
    image_missing: 'IMAGEN FALTANTE',
    image: 'Imagen',
    loading: 'Cargando...',
    unknown_product: 'Producto desconocido',
    unknown_tag: 'Etiqueta desconocida',
    invalid_tag: 'Etiqueta no válida',
    virgin_tag: 'Etiqueta virgen',
    tag_not_associated: 'Etiqueta no asociada',
    killed: 'Eliminado',
    stock: 'Stock',
    valid: 'Válido',
    unknown: 'Desconocido',
    actions: 'Acciones',
    reprint: 'Reimprimir',
    product: 'Producto',
    product_items: 'Artículos del producto',
    identifiers: 'Identificadores',
    zone: 'Zona',
    report_repair: 'Reportar reparación',
    reason: 'Motivo',
    request_code_change: 'Solicitar cambio de código',
    enable_workstation_emulation: 'Habilitar emulación de estación de trabajo',
    enable_browser_print_emulation: 'Habilitar emulación de impresión desde navegador',
    filter: 'Filtro',
    language: 'Idioma',
    warning: 'Advertencia',
    success: 'Éxito',
    info: 'Información',
    checklist: 'Lista de verificación',
    optional: 'Opcional',
    phone: 'Teléfono',
    version: 'Versión',
    printer: 'Impresora',
    new_shipment: 'Nuevo envío',
    upc: 'UPC',
    model_part_color_size: 'Modelo / Parte / Color / Talla',
    confirm_shipment: 'Confirmar envío',
    receive: 'Recibir',
    delete: 'Eliminar',
    delete_association: 'Eliminar asociación',
    change: 'Cambiar',
    from: 'Desde',
    to: 'Hasta',
    ignored: 'Ignorado',
    skipped: 'Omitido',
    ignored_with_reason: 'Ignorado con motivo',
    yes: 'Sí',
    no: 'No',
    model: 'Modelo',
    typology: 'Tipología',
    no_result: 'Sin resultados',
    expected: 'Esperado',
    expected_plural: 'Esperados',
    read: 'Leído',
    missing: 'Faltante',
    unexpected: 'Inesperado',
    unexpected_parcel: 'Caja inesperada',
    ignored_plural: 'Ignoradas',
    serial: 'Número de serie',
    priority: 'Prioridad',
    group: 'Grupo',
    required_quantity: 'Cantidad requerida',
    sorted_quantity: 'Cantidad clasificada',
    missing_quantity: 'Cantidad faltante',
    barcode: 'Código de barras',
    barcode_bc: 'Código de barras BC',
    sorted_date: 'Fecha de clasificación',
    customer: 'Nombre del cliente',
    list: 'Lista',
    list_position: 'Posición en la lista',
    select_date: 'Seleccionar fecha',
    item_info: 'Información del artículo',
    item_events: 'Eventos del artículo',
    operation_type: 'Tipo de operación',
    operation_place: 'Lugar de operación',
    loading_data: 'Por favor espera, cargando datos...',
    empty_item_events: 'No se encontraron eventos',
    show_more: 'Mostrar más',
    hide_more: 'Ocultar',
    production_order: 'Orden de producción',
    production_order_detail: 'Production Order Detail',
    production_order_row: 'Línea de producción',
    production_order_sku: 'SKU de orden de producción',
    kill_tag: 'Eliminar Etiqueta',
    replace_tag: 'Reemplazar Etiqueta',
    replace_tag_with: 'Reemplazar etiqueta con {{tag}}',
    item_po: 'Orden principal del artículo',
    item_order: 'Orden del artículo',
    item_row: 'Fila del artículo',
    pack_code: 'Código de caja',
    send_reads: 'Enviar lecturas',
    items_add_inventory_success: 'Artículos añadidos al inventario',
    new: 'Nuevo',
    confirm_mission: 'Confirmar misión',
    confirm_mission_text: '¿Estás seguro de que deseas confirmar la misión?',
    parziali: 'Parcial',
    total_quantity: 'Cantidad total',
    accepted_quantity: 'Cantidad aceptada',
    country_check: 'Control de país',
    showcase_check: 'Control de la presentación',
    attention: 'Atención',
    clear_items: 'Proceder eliminará todas las lecturas, ¿quieres continuar?',
    add_partial: 'Atención',
    add_partial_text: 'Puede ser necesario crear una Orden de Control de Calidad',
    add_partial_already_text:
      'Puede ser necesario crear una Orden de Control de Calidad. UMG ya ha sido trabajado. ¿Deseas sobrescribir los artículos leídos?',
    error_cq_mission: 'Atención, crea una Orden de Control de Calidad',
    warning_zone_items: 'EN_OTRA_ZONA',
    internal_tag: 'Etiqueta interna',
    external_tag: 'Etiqueta externa',
    error_tag: 'Etiqueta con error',
    awaiting: 'En espera',
    error_logs: 'Registros de errores',
    event_logs: 'Registros de eventos',
    box_closed: 'Caja cerrada',
    box_out: 'Caja fuera',
    unexpected_list: 'Lista de artículos inesperados',
    pending_tags: 'Etiquetas pendientes',
    selected_zone: 'Zona seleccionada',
    pricing: 'Precios',
    send_to_sap: 'Enviar a SAP',
    write_tag: 'Escribir etiqueta',
    identifier_tag: 'Etiqueta identificadora',
    digit_identifier_tag: 'Escribir etiqueta manualmente',
    target_epc: 'EPC objetivo',
    retry_write_tag: 'Se encontró un error al codificar. ¿Deseas intentar codificar la etiqueta nuevamente?',
    ready: 'Listo',
    offline: 'Desconectado',
    shipping_date: 'Fecha de envío',
    update_only_product: 'Artículo ya asociado a otro producto. ¿Estás seguro de que deseas sobrescribirlo?',
    update_production_order_row:
      'Artículo ya asociado a otra fila de orden de producción. ¿Estás seguro de que deseas sobrescribirlo?',
    export: 'Exportar',
    select_zone: 'Seleccionar zona',
    location_origin: 'Sitio de Origen',
    confirm_kill_tag: '¿Qué etiquetas deseas eliminar?',
    kill_in_progress: 'Eliminación de etiquetas en curso',
    confirm_replace_tag: '¿Qué etiquetas deseas reemplazar?',
    replace_in_progress: 'Reemplazo de etiquetas en curso',
    select_tag_to_kill: 'Selecciona la etiqueta que deseas eliminar',
    disassociating_item: 'Desasociando artículo',
    killing_tag: 'Eliminando etiqueta {{type}} con rol {{role}}',
    retry_kill_tag: 'Se encontró un error al eliminar. ¿Deseas intentar nuevamente?',
    reading_tag: 'Leyendo etiqueta',
    writing_tag: 'Escribir etiquetas',
    writing_tag_with: 'Escribir etiquetas {{tag}}',
    navBackWarning: '¿Seguro que quieres volver atrás? Todos los cambios no guardados, como las lecturas, se perderán.',
    sentry: {
      report_problem: 'Describe el problema que encontraste o sugiere una mejora'
    },
    ready_to_read: 'Listo para leer',
    remove_product_readings: 'Eliminar lecturas del producto',
    ok: 'OK',
    already_in_parcel: 'Ya en caja',
    operation_canceled_by_user: 'Operación cancelada por el usuario',
    load_more: 'cargando en curso',
    input: 'Entrada',
    rfid_barcodes: 'Códigos de barras RFID',
    submit: 'Enviar',
    //valentino
    error: 'Error',
    OK_WORKER: 'TRABAJADOR OK',
    KO_WORKER: 'TRABAJADOR KO',
    OK_REPAIR: 'REPARACIÓN OK',
    RESO_RICHIESTO_CQ: 'CONTROL DE CALIDAD SOLICITADO',
    RESO_OK: 'DEVOLUCIÓN OK',
    OK_VALDAGNO: 'VALDAGNO OK',
    KO_VALDAGNO: 'VALDAGNO KO',
    SECOND_VALDAGNO: 'SEGUNDA ELECCIÓN',
    OK_LINING: 'FORRO OK',
    ok_first_inbound_status: 'PRIMER INGRESO OK',
    OK_RISC: 'RIESGO',
    KO_LINING: 'FORRO KO',
    size_color: 'Talla/Color',
    select_size_color: 'Selecciona talla/color',
    print: 'Imprimir',
    missings: 'Faltantes',
    embedded: 'Incorporado',
    ignoreds: 'Ignorados',
    select_printer: 'Seleccionar impresora',
    printing_started: 'Impresión iniciada',
    release_reports: 'Emitir informes',
    quality_checks: 'Controles de calidad',
    quality_check: 'Control de calidad',
    total_mission_qty: 'Cantidad total de la misión',
    inbound_read_qty: 'Cantidad leída en entrada',
    checked_qty: 'Cantidad verificada',
    checked: 'Verificados',
    returned: 'Devueltos',
    damaged: 'Dañados',
    qty_damaged_first_check: 'Cantidad dañada en el primer control',
    first_check_date: 'Fecha del primer control',
    qty_damaged_second_check: 'Cantidad dañada en el segundo control',
    second_check_date: 'Fecha del segundo control',
    note: 'Nota',
    work_order: 'Orden de trabajo',
    order_type: 'Tipo de orden',
    //louis vuitton
    start_and_read: 'Por favor, inicia las antenas y coloca el producto',
    emulate: 'Emulate',
    advanced_emulation: 'Advanced Emulation',
    emulation_history: 'Emulation History',
    emulation_favorites: 'Favorites',
    power: 'Power',
    sensitivity: 'Sensitivity',
    expected_quantity: 'Expected',
    extra_quantity: 'Extra',
    encoded_quantity: 'Encoded',
    products: 'Productos',
    last_paired_sn: 'Último SN emparejado',
    last_confirmed_ucs: 'Último UCS confirmado'
  },
  error: {
    error: 'Error',
    errors: 'Errores',
    forbidden: 'Prohibido',
    not_found: 'No encontrado',
    product_not_found: 'Product Not Found',
    unauthorized: 'No autorizado',
    too_many_tags_read: 'Demasiadas etiquetas leídas (esperado {{exptected}}, leído {{read}})',
    too_many_checklist_types: 'Demasiados tipos de checklist.',
    rfid_discrepancies_found: 'Se encontraron discrepancias RFID.',
    certilogo_not_found: 'Certilogo "{{code}}" no encontrado',
    ean_not_found: 'EAN "{{code}}" no encontrado',
    production_order_not_found: 'Orden de producción "{{code}}" no encontrada',
    no_inbound_zones: 'No hay zonas de entrada',
    no_operation_config: 'Configuración de operación no encontrada',
    not_supported_reading_mode: 'Modo de lectura no soportado',
    undefined_operation_config: 'La configuración de operación no puede estar indefinida',
    certilogo_already_encoded: 'Certilogo "{{code}}" ya codificado',
    tag_not_found: 'Etiqueta no encontrada',
    missing_printer_id: 'IP de impresora faltante',
    tag_unassociated: 'Etiqueta no asociada',
    tag_type_unexpected: 'Tipo de etiqueta inesperado',
    tag_already_associated: 'Etiqueta ya asociada. Primero debes desasociarla',
    tags_not_associated: 'Una o más etiquetas no están asociadas',
    tags_mismatch: 'Incompatibilidad de etiquetas',
    workstation_could_not_be_started: 'No se pudo iniciar la estación de trabajo {{code}}',
    antenna_was_started: 'La antena {{code}} se inició',
    antenna_was_not_started: 'La antena {{code}} no se inició',
    authentication_failed: 'Autenticación fallida',
    field_required: 'El campo {{label}} es obligatorio',
    unable_to_connect_to_rfid_reader: 'No se pudo conectar al lector RFID. Verifica que el dispositivo esté encendido.',
    items_in_error_found: 'Se encontraron artículos con error',
    item_not_in_inbound: 'Artículo no está en entrada',
    item_not_in_stock: 'Artículo no en stock',
    item_in_another_parcel: 'Artículo en otra caja',
    item_in_another_production_order: 'Artículo en otra orden de producción',
    connection: 'Error de conexión',
    connection_details:
      'No hubo respuesta del servidor. Por favor, verifica tu conexión a internet o la configuración de la VPN.',
    field_invalid_default: 'Valor predeterminado "{{defaultValue}}" no válido para el campo {{field}}',
    field_invalid_default_from_endpoint: 'No se pudo encontrar un valor para el campo {{field}}',
    sorting_already_read: 'Artículo con número de serie {{serial}} ya leído en el grupo {{group}}',
    sorting_no_group: 'Artículo no clasificable',
    sorting_not_in_zone: 'Artículo con número de serie {{serial}} no clasificable. Ya está en la zona {{zone}}',
    sorting_unknown: 'Etiqueta {{tag}} no válida',
    sorting_unexpected: 'Etiqueta inesperada',
    no_item_configuration: 'Configuración de artículo no encontrada',
    item_creation_error: 'Error al crear el artículo',
    couldn_find_production_order: 'No se pudo encontrar la orden de producción',
    couldn_find_production_order_row: 'No se pudo encontrar la fila de la orden de producción',
    missing_operation_option: 'Opción de operación faltante: {{error}}',
    item_session_list_create: 'Lista no creada',
    item_session_list_create_session: 'Sesión de lista no creada',
    item_session_list_confirm: 'Lista no confirmada',
    item_session_list_confirm_session: 'Sesión de lista no confirmada',
    form_validation: 'Validación de formulario',
    form_validation_message: 'Error al completar el campo',
    select_place_error: 'No se pudo guardar el lugar de origen',
    self_user_data: 'No se pudieron guardar tus datos',
    encoding_no_tags: 'No se han leído más etiquetas. Operación abortada',
    only_virgin_tag: 'Solo se detectaron etiquetas vírgenes',
    tags_mismatch_error: 'Por favor, lee una etiqueta a la vez',
    tags_errors: 'Errores de etiquetas',
    value_not_valid: 'El valor introducido no es válido',
    write_tag: 'Error desconocido al escribir la etiqueta',
    WRONG_PRODUCTION_ORDER: 'Orden de producción incorrecta',
    WRONG_PLACE: 'Lugar incorrecto',
    PRODUCTION_ORDER_ROW_CREATION_ERROR: 'Error al crear la fila de orden de producción',
    force_tag_associated: 'Etiqueta ya asociada. ¿Reasociar?',
    operation_confirm_error: 'Error al confirmar la operación',
    missing_mandatory_qc: 'Sin control de calidad. ¿Proceder?',
    wrong_qc_status: 'El producto fue declarado KO. ¿Proceder?',
    wrong_qc_size: 'Verifica la talla. ¿Proceder?',
    wrong_qc_size_payload: 'Talla codificada: {{productSize}} - Talla física: {{manualSize}}. ¿Proceder?',
    wrong_qc_model: 'Verifica el modelo. ¿Proceder?',
    start_checklist: 'Checklist no iniciada',
    confirm_with_unexpected: 'No se puede confirmar con etiquetas inesperadas',
    confirm_with_overqty: 'No se puede confirmar con etiquetas en exceso de cantidad',
    rfid_reader_initialization: 'Error desconocido al inicializar el lector RFID',
    remove_sap_item_error: 'No se pudo eliminar el artículo',
    no_asn_selected: 'Ningún ASN seleccionado',
    submit_asn: 'Error al enviar ASN',
    zbpNotFound: 'Zebra Browser Print no encontrado en tu sistema. Asegúrate de que esté instalado y en ejecución',
    no_printer_selected: 'Ninguna impresora seleccionada',
    zplTemplateNotDefined:
      "Plantilla ZPL no definida. Por favor, establece un código de plantilla en el atributo 'zpl-template-code' de la configuración de operación",
    no_print_template: 'Plantilla de impresión no encontrada',
    wrong_tag: 'Etiqueta incorrecta',
    tag_error_or_not_authentic: 'Etiqueta no auténtica o error de autenticación',
    authentication_timeout: 'Tiempo de espera de autenticación',
    tid_missing: 'Falta el TID de la etiqueta leída',
    on_destination: 'en destino {{destination}}',
    item_not_sortable: 'El artículo con número de serie {{serial}} no es clasificable',
    search_error: 'Error de búsqueda',
    no_parcel_found_by_identifier: 'No se encontró ningún paquete con estos identificadores',
    kill_tag_not_allowed:
      'No es posible eliminar una etiqueta asociada a un artículo. Para eliminarla, primero desasocia el artículo.',
    kill_already_killed: 'Etiqueta ya eliminada',
    can_kill_only_tag_type: 'Sólo puedes matar etiquetas {{type}}',
    replace_tag_not_allowed: 'Solo puedes reemplazar etiquetas asociadas a un artículo',
    kill_tag_not_success: 'No se pudo eliminar la etiqueta',
    replace_tag_not_success: 'No se pudo reemplazar la etiqueta',
    nfc_tag_not_expected: 'Etiqueta NFC no esperada para este producto',
    ventilation_quantity_reached: 'Ya se ha alcanzado la cantidad a ventilar para este producto',
    confirm_not_allowed_with_errors: 'Confirmación no permitida debido a errores',
    close_not_allowed_with_errors: 'Cierre no permitido debido a errores',
    generic: 'Ocurrió un error al enviar la retroalimentación',
    form_entry: 'Algunos campos son obligatorios',
    invalid_tag_read: 'Lectura de etiqueta no válida',
    read_one_tag_time: 'Lee solo una etiqueta a la vez',
    validation_failed_rewrite: 'Falló la validación de la configuración de reescritura',
    uhf_tag_not_found: 'Etiqueta UHF no encontrada',
    compute_tags_failed: 'Falló la generación de la etiqueta a escribir',
    be_generic_error: 'Error del sistema',
    be_generic_error_description: 'Ocurrió un error genérico en el sistema.',
    identifier_production_order_not_found: 'Orden de producción no encontrada',
    gs1code_invalid: 'GS1 code not valid',
    productionorderrow_mismatch: 'Incompatibilidad de fila de orden de producción. ¿Proceder de todas formas?',
    //cucinelli
    nfc_already_associated: 'NFC ya asociada. Desasóciala y repite la operación',
    too_many_valid_tag_read: 'Demasiadas etiquetas válidas leídas',
    fields_required: ' es obligatorio',
    exceeded_quantity: 'Exceeded quantity',
    production_order_completed: 'Se completa la orden de producción',
    production_order_row_completed: 'Se completa la fila de la orden de producción',
    replace_tag_not_allowed_for_this_tag: 'No es posible reemplazar este tipo de etiqueta.',
    box_already_received: 'Caja ya recibida. Omitir lectura.',
    MISSING_EAN_ATTRIBUTE: 'EAN no encontrado para el producto {{productCode}}',
    other_production_order: 'Ya asociado a una orden de producción y producto diferente'
  },
  messages: {
    no_operations_found: 'No se encontraron operaciones. Verifica los permisos del usuario en el Panel de Control',
    not_allowed_operation: 'No tienes permiso para realizar esta operación. Por favor, verifica tu configuración',
    no_workstations_found: 'No se encontraron estaciones de trabajo',
    no_workstation_selected: 'Ninguna estación de trabajo seleccionada',
    are_you_sure_to_reset_daily_items: '¿Estás seguro de que deseas reiniciar los elementos diarios?',
    bring_an_item_to_antenna: 'Acerca un artículo a la antena',
    press_start_to_read: 'Presiona el botón Iniciar para \ncomenzar a leer productos RFID',
    reading_in_progress: 'Lectura en curso',
    waiting_for_product: 'Esperando el producto...',
    paste_comma_separeted_tags: 'Pega las etiquetas separadas por comas y presiona Enter...',
    connection_workstation_progress: 'Conexión con la estación de trabajo en curso...',
    operation_success: 'Operación confirmada con éxito',
    outbound_success: 'Salida confirmada con éxito',
    inbound_success: 'Entrada confirmada con éxito',
    pack_success: 'Embalaje confirmado con éxito',
    transfer_to_zone_success: 'Transferencia a zona confirmada con éxito',
    simple_item_list_success: 'Lista simple de artículos confirmada con éxito',
    list_empty: 'La lista está vacía',
    looks_like_anything_in_list: 'Parece que no tienes nada en tu lista',
    generic_success: '{{code}} confirmado con éxito',
    generic_success_canceled: '{{code}} cancelado con éxito',
    generic_error: 'Error en {{code}}',
    fill_all_fields_and_search_an_item_configuration: 'Rellena todos los campos y busca una configuración de artículo',
    encoding_success: 'Codificación confirmada con éxito',
    encoding_success_none: 'El artículo ya fue asociado anteriormente',
    read_some_identifier_to_start_verification: 'Lee algún identificador para iniciar la verificación',
    warning_items_found: 'Se encontraron artículos con advertencias',
    are_you_sure_you_want_to_confirm: '¿Estás seguro de que deseas confirmar?',
    item_session_list_confirm: 'Lista confirmada con éxito',
    operation_in_progress: 'Operación en curso, por favor espera...',
    sorting_error_zones: 'Zona de origen no valorada, imposible continuar con la ventilación',
    connection_in_progress: 'Conexión en curso...',
    checklist_there_are: 'Hay',
    checklist_missings: 'artículos faltantes',
    checklist_overqty: 'artículos en exceso',
    checklist_unexpecteds: 'artículos inesperados',
    checklist_confirm_mismatch_question: '¿Estás seguro de que deseas confirmar de todas formas?',
    force_update_content: '¿Estás seguro de que deseas forzar el envío a SAP?',
    connection_to_station_in_progress: 'Conexión a la estación en curso',
    tag_killed: 'Etiqueta eliminada',
    tag_replaced: 'Etiqueta reemplazada',
    tag_deleted: 'Etiqueta borrada',
    write_tag: 'Etiqueta escrita con éxito',
    not_ready: 'No listo',
    readyf: 'Listo',
    nfcDecryption: 'Descifrado NFC. Por favor, mantén la etiqueta quieta',
    parcel_success: 'Caja confirmada con éxito',
    sentry: {
      success: '¡Gracias por tu comentario! Tu contribución nos ayuda a mejorar nuestro servicio.'
    },
    confirm_force_shipment: 'Confirmar envío con PFAS',
    input_rfid_barcodes: 'Por favor, introduce los códigos RFID separados por coma o nueva línea',
    //valentino
    are_you_sure_to_clear_reads: '¿Estás seguro de querer borrar las lecturas?',
    are_you_sure_to_confirm: '¿Estás seguro de querer confirmar?',
    inbound_conveyor_confirm_missing_message: 'Todavía hay artículos -faltantes-, ¿estás seguro de querer confirmar?',
    ///
    newVersionAvailable: 'Nueva versión disponible',
    pageWillReload: 'La página se recargará automáticamente en 30 segundos',
    update_available_description: 'Hay una actualización disponible para esta página. Por favor, recárgala.',
    deviceManagerUpdateTitle: 'Actualización del Administrador de Dispositivos',
    deviceManagerUpdateDescription:
      'Hay una nueva actualización disponible para el Administrador de Dispositivos (el software que integra el lector RFID). Actualízalo ahora para garantizar un funcionamiento óptimo.',
    deviceManagerUpdating: 'Actualización del Administrador de Dispositivos en curso…',
    deviceManagerUpdateCompleted: 'Actualización completada con éxito',
    deviceManagerUpdateCompletedAndRequiresReboot:
      'Actualización completada con éxito. Por favor, reinicia el sistema para aplicar la actualización.',
    exceeded_quantity_message:
      'The quantity for the production order row has been reached. Make sure to change the row or the production order.',
    empty_production_order: 'No rows present in the production order',
    empty_production_order_search: 'No production order rows matches the search performed'
  },
  placeholder: {
    search_shipment_parcel: 'Buscar envío o caja',
    search_product_parcel: 'Buscar producto o caja'
  },
  confirm: {
    discrepancy_title: 'Caja con discrepancias',
    discrepancy_message: 'Se encontraron productos con discrepancias. ¿Estás seguro de que deseas confirmar la caja',
    confirm_delete_association: '¿Estás seguro de que deseas eliminar esta asociación de artículo?',
    confirm_delete_operation_title: 'Eliminar {{operation}}',
    confirm_delete_operation: '¿Deseas eliminar la operación? Todos los artículos leídos se perderán.',
    confirm_delete_item_association: '¿Estás seguro de que deseas eliminar esta asociación de artículo?',
    confirm_kill_tag: '¿Estás seguro de que deseas eliminar la etiqueta {{type}} {{tag}}?',
    confirm_multiple_kill_tag: '¿Estás seguro de que deseas eliminar todas las etiquetas?',
    confirm_disassociate_kill_tag: '¿Estás seguro de que deseas desasociar y eliminar la etiqueta {{type}} {{tag}}?',
    confirm_disassociate_multiple_kill_tag: '¿Estás seguro de que deseas desasociar y eliminar todas las etiquetas?',
    confirm_operation_title: 'Confirmar {{operation}}',
    confirm_operation_text: '¿Deseas confirmar la operación?',
    confirm_operation_text_irreversible: '¿Deseas confirmar la operación? Esta acción no se puede revertir.',
    confirm_operation_text_partial_confirm: 'Enviando lectura a JDE. ¿Estás seguro de continuar?',
    confirm_operation_text_partial_confirm_without_jde: '¿Estás seguro de querer continuar?',
    post_confirm_action_title: 'Continuar',
    post_confirm_action_keep_input: 'Operación completada. ¿Deseas realizar otra operación?',
    post_confirm_action_change_input: 'Operación completada. ¿Deseas realizar otra operación?',
    confirm_close_asn_title: 'Confirmación de cierre',
    confirm_close_asn_text:
      'Algunas cajas no han sido recibidas. ¿Estás seguro de que deseas FORZAR el cierre de este envío?',
    unpack: 'Paquete ya embalado. ¿Deseas proceder con el desembalaje y volver a embalar?',
    last_parcel_confirmerd: 'Confirmed all packages of shipment {{code}}. Close the shipment too?'
  },
  labels: {
    draft: 'Borrador',
    ready_to_send: 'Listo para enviar',
    send_await: 'Pendiente',
    outbound_error: 'Error de salida',
    sent: 'Enviado',
    in_inbound: 'En entrada',
    receive_await: 'Pendiente',
    ready_to_receive: 'Por recibir',
    inbound_error: 'Error de entrada',
    received: 'Recibido',
    in_transit: 'En tránsito'
  },
  serverError: {
    //moncler
    WRONG_ITEM_SUPPLIER: 'Algunos artículos leídos no pueden ser asumidos por el proveedor.',
    QUANTITY_MISMATCH_ERROR: 'Las cantidades ingresadas no corresponden a las cantidades detectadas.',
    ZONE_MISMATCH_ERROR: 'La zona ingresada no corresponde a la zona detectada.'
  },
  error_messages: {
    password_required: 'El campo de contraseña es obligatorio',
    invalid_password: 'Contraseña inválida',
    //moncler
    missing_workstation_place: 'Falta el lugar de la estación de trabajo'
  },
  report_tbox: {
    umg: 'Umg',
    ddt_number: 'DDT N.',
    creation_date: 'Date',
    capi_mdc: 'Capi MDC',
    qt_totale: 'Total Qty',
    qt_accettata: 'Accepeted Qty',
    qt_scartata: 'Rejected Qty',
    supplier: 'Supplier',
    notes: 'Notes'
  },
  custom: {
    countTBoxParcel: 'Parcel',
    countTBoxDDT: 'DDT',
    BARCODE_READ: 'Código de barras leído',
    RFID_START_READING: 'Iniciar lectura',
    RFID_STOP_READING: 'Detener lectura',
    RESULT_EVENT: 'Evento de resultado',
    TRACE: 'Trazabilidad',
    INFO: 'Info',
    WARNING: 'Advertencia',
    ERROR: 'Error',
    deleteSession: 'Eliminar paquete',
    deleteSessionMessage: '¿Estás seguro de que deseas eliminar el paquete?',
    deleteList: 'Eliminar DDT',
    deleteListMessage: '¿Estás seguro de que deseas eliminar el DDT?',
    WAM: 'SKU',
    sap_warning: 'SAP warning',
    total_list: 'Lista total',
    total_parcel: 'Total paquetes',
    order_number: 'Número de orden',
    addon: 'Addon',
    componentType: 'Component Type',
    //cucinelli
    barcode: 'Barcode BC',
    barcodeBCTrim: 'Barcode BC trim',
    barcodeJDE: 'Barcode JDE',
    barcodeROQ: 'Barcode ROQ',
    barcodeROQTrim: 'Barcode ROQ trim',
    class: 'Class',
    department: 'Department',
    dimensionSystem: 'Custom class',
    ean: 'EAN',
    eanIdPadre: 'Father EAN',
    itemId: 'Item Id',
    stagioneROQ: 'ROQ season',
    subclass: 'Model Type',
    subdepartment: 'Subdepartment',
    variantType: 'Typology ',
    variantModel: 'Variant model',
    cardCode: 'Card code',
    label: 'Label',
    rfidEnabled: 'RFID enabled',
    stato: 'Status',
    ricondizionamentoFornitore: 'Recondition supplier',
    codiceShelf: 'Stock Compartment',
    montante: 'Section',
    ripiano: 'Bin',
    scaffale: 'Bay',
    ASSOCIATED: 'Asociado',
    NOT_ASSOCIATED: 'No asociado',
    REPLACED_ASSOCIATION: 'Reemplazado',
    identifiers: 'Identifiers',
    force_parcel: 'Force parcel',
    force_parcel_message: 'Are you sure you want to force this parcel?',
    pesa_collo: 'Weight neck',
    peso_kg: 'Weight (kg)',
    wrong_packaging_code: 'Wrong packing code',
    packaging_confirmed_no_weight: 'You are confirming a package without weight, do you want to continue?',
    attention: 'Attention',
    continue: 'Continue',
    model: 'Modello',
    sizeCode: 'Size code',
    sizeDescription: 'Size description',
    serial: 'Serial',
    identifier: 'Serial',
    product: 'Barcode BC',
    shift: 'Shift',
    destination: 'Destination',
    regDate: 'Date',
    listPosition: 'List position',
    list: 'List',
    customerName: 'Customer Name',
    regTime: 'Time',
    event: 'Event',
    customer: 'Customer',
    isCarryover: 'Carryover',
    carryoverValue: 'Carryover',
    madeIn: 'Made in',
    collectionCode: 'Collection',
    collectionDescription: 'Collection Description',
    collectionYear: 'Year',
    fatherProductValue: 'Father Product',
    genderValue: 'Gender',
    genderValueDescription: 'Gender Description',
    line: 'Brandline',
    lineDescription: 'Line Description',
    marchioDescription: 'Marchio Description',
    marchioValue: 'Marchio',
    merchandiseClassCode: 'Category',
    merchandiseClassDescription: 'Category Description',
    merchandiseSubclassCode: 'Sub-Category',
    merchandiseSubclassDescription: 'Sub-Category Description',
    modelPartColor: 'Model Part Color',
    modelPartColorSizeValue: 'Model Part Color Size',
    isPermanent: 'Permanent',
    permanentValue: 'Permanent',
    isSeasonal: 'Seasonal',
    seasonalValue: 'Seasonal',
    sleeveTypeValue: 'Sleeve Type',
    origin_location_mandatory_field_error: 'Origin location is required',
    transactionDate_mandatory_field_error: 'Transaction date is required',
    customerCode_mandatory_field_error: 'Customer code is required',
    tipology_field_error: 'Tipology is required',
    warehouseUsa_relabeling_mandatory_fields_error: 'Reballing is required',
    //valentino
    sconosciuto: 'UNKNOWN',
    prodottoSconosciuto: 'Unknown product',
    reads_ok: 'READS OK',
    tot_to_check: 'Total to check',
    //moncler
    confirm_force_received_text: 'This shipment has already been confirmed. Would you like to remove it from the list?',
    //louis vuitton
    tooManyTags: 'Demasiadas etiquetas',
    nfcDetectedPleaseUseProductControl:
      'Etiqueta NFC detectada. Por favor, usa la funcionalidad de Control de Producto.',
    GENERIC_ERROR: 'Error genérico - Por favor, contacta con soporte vía ContactIS',
    ECERTIFICATE_WORKORDER_NOT_FOUND: 'Orden de trabajo no encontrada en eCertificate',
    ITEM_IN_ANOTHER_PARCEL: 'Este artículo ya ha sido declarado en otro paquete',
    ECERTIFICATE_WORKORDER_CREATED_BOT_NOT_COMPLETED: 'La orden ha sido creada en eCertificate pero no completada',
    INVALID_TIMESTAMP: 'Marca de tiempo no válida',
    INVALID_SERIAL: 'Número de serie no válido',
    INVALID_WORKORDER: 'Número de orden de trabajo no válido',
    INVALID_SKU: 'SKU no válido',
    INVALID_PARCEL_NUMBER: 'Número de paquete no válido',
    SAP_UCS_NOT_CONFIRMED: 'UCS *{parcelCode} no confirmado al final de la línea de ensamblaje',
    SAP_REMOVABLE_SYNCHRO_NOT_PERFORMED: 'Sincronización removible no realizada',
    SAP_INCORRECT_OPERATION_STATUS: 'El estado de la operación de UCS *{parcelCode} no es correcto en SAP ME',
    SAP_COMPLETED_NOT_FOUND_IN_TNT: 'UCS ya completado en SAP, no presente en T&T',
    SAP_UCS_CANNOT_BE_COMPLETED: 'UCS *{parcelCode} no puede ser completado en SAP ME/MII',
    SAP_WORKORDER_CLOSED: 'La orden de trabajo asociada a UCS *{parcelCode} está cerrada en SAP MII',
    SAP_INTERNAL_ERROR: 'Error técnico en SAP MII',
    SAP_TIMEOUT_BUT_OK_AGGREGATION: 'Tiempo agotado -> Agregación OK',
    LVSP_PARCEL_NUMBER_ALREADY_AGGREGATED: 'Número de paquete ya agregado en LVSP',
    LVSP_SERIAL_ALREADY_AGGREGATED: 'Número de serie ya agregado previamente en LVSP',
    LVSP_MISMATCH_EXPECTED_QUANTITY: 'Diferencia entre cantidad escaneada y cantidad esperada en LVSP',
    LVSP_SKU_NOT_FOUND: 'SKU desconocido en LVSP',
    LVSP_SUPPLIER_NOT_FOUND: 'Proveedor desconocido en LVSP',
    TECHNICAL_ERROR: 'Problema técnico - por favor contacta con soporte vía ContactIS',
    ERROR_IN_PARCEL_ITEMS:
      'An error occurred while confirming the parcel. Please empty the parcel using the trash icon, then scan all items again',
    NFC_PRODUCT_NOT_ALLOWED:
      'El SKU requiere una etiqueta NFC. Por favor, usa la funcionalidad de Control de Producto.',
    row: 'Row',
    longSKU: 'Long SKU',
    pairingDate: 'Production Date',
    citesFlag: 'Cites',
    pairingSupplier: 'Supplier',
    batchNumber: 'Batch',
    status: 'Status',
    chrono: 'Chrono',
    logisticStatus: 'Product Status',
    serialNumber: 'RFID Serial Number',
    returnCode: 'Return Code',
    viewCitesDocument: 'View CITES Document',
    // others
    reference: 'Reference',
    sender: 'Sender',
    year: 'Year',
    number: 'Number',
    TAG_STATUS_CONFIRMED: 'Già associato'
  },
  imbustatrice: {
    and: ' and ',
    unkwon_tag: 'Unkwon Tag',
    dynamic_tag: '{{role}} Tag',
    dynamic_tag_missing: '{{role}} Tag missing',
    too_many_dynamic_tags: 'Too many {{role}} tags',
    dynamic_tag_already_associated: '{{role}} tag already associated',
    wrong_tag: 'Wrong Tag',
    missing_tag: 'Tag missing'
  },
  identifier_error: {
    ALREADY_ASSOCIATED_TAG: 'Ya asociada',
    WRONG_QC_STATUS: 'Wrong quality control status',
    WRONG_QC_SIZE: 'Wrong quality control size',
    WRONG_QC_MODEL: 'Wrong quality control model',
    MISSING_MANDATORY_QC: 'Missing quality control',
    MISSING_PRODUCT_INFO: 'Falta información del producto',
    WRONG_TAG: 'Etiqueta incorrecta',
    UNKNOWN_TAG: 'Etiqueta desconocida',
    WRONG_PRODUCT: 'Producto incorrecto',
    MISSING_MANDATORY_TAG: 'Falta etiqueta obligatoria',
    MISSING_OPTIONAL_TAG: 'Falta etiqueta opcional',
    EXTRA_TAG: 'Etiqueta adicional',
    TAG_MISMATCH: 'Etiqueta no coincide',
    PRODUCTIONORDERROW_MISMATCH: 'Asociación de fila de orden de producción no coincide',
    MISSING_SYSTEM_TAG: 'Etiqueta desconocida',
    UNEXPECTED_TAG: 'Etiqueta inesperada',
    NOT_EXISTING_CERTILOGO_TAG: 'Certilogo code not present in the system',
    KILLED_TAG: 'Killed tag',
    MISSING_TAG: 'Missing tag'
  },
  statuses: {
    RESTORE_VARIANT: 'RESTAURAR TIPOLOGÍA',
    CONFIRM_ERROR: 'ERROR DE CONFIRMACIÓN'
  },
  userSettings: {
    title: 'Configuraciones del usuario',
    autostopAntennaTimeout: 'Tiempo de espera para detener antenas (ms)',
    autostartAntenna: 'Inicio automático de antena',
    autoConfirmParcel: 'Confirmación automática del paquete',
    barcodeItemRead: 'Lectura de artículo por código de barras',
    antennas: 'Antennas settings',
    resetReadingsAfterOperation: 'Velocidad de reinicio después de la confirmación',
    slow: 'Lento',
    medium: 'Medio',
    fast: 'Rápido',
    printerCode: 'Código de impresora',
    enableOkSounds: 'Sonidos OK',
    enableKoSounds: 'Sonidos KO'
  },
  attributes: {
    material: 'Material',
    workerCode: 'Código del trabajador',
    workerExternalCode: 'Código externo del trabajador',
    workerIdentifier: 'Identificador del trabajador',
    workerDescription: 'Descripción del trabajador',
    workerType: 'Tipo de trabajador',
    orderCode: 'Código de orden',
    sapQualityControlStatus: 'SAP Quality Control Status',
    quantityOkWorker: 'OK WORKER QTY',
    quantityKoWorker: 'KO WORKER QTY',
    quantityOkRepair: 'OK REPAIR QTY',
    quantityOkValdagno: 'OK VALDAGNO QTY',
    quantityOkFirstInbound: 'OK FIRST INBOUND QTY',
    quantityOkRis: 'RISK QTY',
    quantityKoValdagno: 'KO VALDAGNO QTY',
    quantitySecondValdagno: 'SECOND CHOICE QTY',
    quantityOkLining: 'OK LINING QTY',
    quantityKoLining: 'KO LINING QTY'
  },
  title: {
    report_problem: 'Reportar un problema',
    delete_shipment_title: 'Delete Confirmation'
  },
  subtitle: {
    report_problem: 'Describe el problema que encontraste o sugiere una mejora',
    delete_shipment_message: 'Are you sure you want to delete this shipment?'
  },
  label: {
    name: 'Nombre',
    email: 'Correo electrónico',
    description: 'Descripción del problema',
    close: 'Cerrar',
    submit: 'Enviar comentarios'
  },
  success: {
    message: '¡Gracias por tus comentarios!'
  },
  button: {
    submit: 'Enviar comentarios'
  }
}
